module.exports = __webpack_public_path__ + "static/media/appyhere-logo.2ce3368e.svg";